module.exports = __webpack_public_path__ + "static/media/serviceProviderimg3.280a3056.png";